import React, { useContext } from 'react';
import { EYELASHES } from 'Root/constants';
import { EyeLashes, ColorShade } from 'Components/commonComponents';
import AppContext from 'Components/context';
import VmContext from 'Components/virtualMirror/context';

const Shades = ({ shades, type, shadeSelected, makeupList, onShadeClick }) => {
  const { makeupCleared } = useContext(AppContext);
  const { selectedTab } = useContext(VmContext);
  return (
    <ul className={`shades shades--${type} ${selectedTab}`}>
      {shades.map((shade) => {
        // Mapping shades
        const { id, color_code } = shade;
        const isEyeShadow = shade.color_codes;
        if (!isEyeShadow) {
          return (
            <li
              key={id}
              onClick={() => onShadeClick(shade)}
              className={
                (shadeSelected === id || makeupList.indexOf(id) > -1) &&
                !makeupCleared
                  ? `shades--item active`
                  : `shades--item`
              }
            >
              {type === EYELASHES ? (
                <EyeLashes imageName={shade['img']} isCustomeMakeup={false} /> // Image name = skuId
              ) : (
                <ColorShade colorCode={color_code} />
              )}
            </li>
          );
        }

        return (
          <li
            key={shade.id}
            onClick={() => onShadeClick(shade)}
            className={
              shadeSelected === shade.id || makeupList.indexOf(shade.id) > -1
                ? `shades--item active`
                : `shades--item`
            }
          >
            {shade.color_codes.map((code, key) => (
              <ColorShade key={key} colorCode={code} />
            ))}
          </li>
        );
      })}
    </ul>
  );
};

export default Shades;
